import { render, staticRenderFns } from "./PrestaIssueStatusChip.vue?vue&type=template&id=445b2720&scoped=true"
import script from "./PrestaIssueStatusChip.vue?vue&type=script&lang=js"
export * from "./PrestaIssueStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b2720",
  null
  
)

export default component.exports